// A tela é da rota-pai (`admin.reconciliation.tsx`), porque ela continua desenhada
// embaixo quando a execução abre no drawer (`spec/24` §1 decisão 5). Esta rota-índice
// existe só para `/admin/reconciliation` ser um destino válido do roteador.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/reconciliation/')({ component: () => null });
